import React, { useEffect, useState } from 'react';
import { Form, Input, Modal, Select } from 'antd';
import { LeftArrowIcon } from 'assets/icons/AntDeisgn_icons/iconStyle';
import { BackButton, StyledButton } from 'component/button_components/button_general/ButtonGeneralStyle';
import { AntDivider, FormItem, FormSubmitButtonConatainer } from 'component/form_component/style';
import { AdminPageSizeWrap, AdminPageWrap, AdminTitleWrap } from 'pages/admin_page/style';
import {
  CustomizeButton,
  ImgWrap,
  ThemeActionButtonWrap,
  ThemeContentBox,
  ThemeContentWrap,
  ThemeNameDisplay,
  ThumbNailWrap,
} from './style';
import { useDispatch, useSelector } from 'react-redux';
import { createTheme, deleteTheme, getThemes, setThemeForCustomize } from 'redux/slices/themeSlice';
import { useNavigate } from 'react-router-dom';
import { CreateContendwrap } from 'component/create_ou_component/create_childOu_components/style';
import { SweetSweetAlert } from 'component/sweetalert_components';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';
import Swal from 'sweetalert2';
import TableLoader from 'component/loader_component/tableLoader';

export default function Themes() {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const { themeData, themeloading } = useSelector((state) => state.themes);
  const [themeBoxes, setThemeBoxes] = useState([]);
  const { Option } = Select;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleCreateTheme = async (value) => {
    const [baseName, defaultName] = value.baseTheme.split('|');
    value.baseTheme = baseName;
    value.defaultTheme = defaultName;
    try {
      setLoading(true);
      setIsModalVisible(false);
      const sweetAlert = await dispatch(createTheme(value));
      if (sweetAlert?.payload?.status === 200) {
        await SweetSweetAlert({ sweetData: 'Theme Created Successfully', icon: 'success', buttonColor: 'green' });
        await dispatch(
          setThemeForCustomize({
            baseTheme: sweetAlert.payload.data.theme.baseTheme,
            themeName: sweetAlert.payload.data.theme.themeName,
            defaultTheme: sweetAlert.payload.data.theme.defaultTheme,
          })
        );
        navigate('/customize_theme');
      } else if (sweetAlert?.payload?.status === 409) {
        SweetSweetAlert({ text: 'ThemeName Already Exists. !!', icon: 'error', buttonColor: 'red' });
      } else {
        SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      }
    } catch (error) {
      SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    dispatch(getThemes());
  }, []);
  useEffect(() => {
    const fetchThemeImages = async () => {
      const fetchedBoxes = await Promise.all(
        themeData.map(async (theme, index) => {
          try {
            const response = await fetch(`/themes/${theme.themeName}/themedata.json?_=${new Date().getTime()}`, {
              headers: {
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache',
                Expires: '0',
              },
            });
            if (!response.ok) {
              throw new Error(`Failed to fetch: ${response.status} ${response.statusText}`);
            }
            const themedata = await response.json();
            const imageSrc = themedata.images && themedata.images.thumbnail ? themedata.images.thumbnail : '';

            const handleDelete = async () => {
              const result = await Swal.fire({
                icon: 'warning',
                title: 'Are you sure you want to delete?',
                showConfirmButton: true,
                confirmButtonColor: 'var(--bg-button-default-color)',
                width: '400px',
                heightAuto: false,
                showCancelButton: true,
                cancelButtonColor: 'green',
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                reverseButtons: true,
                customClass: {
                  container: 'custom-swal-container',
                  icon: 'custom-swal-icon',
                  title: 'custom-swal-title',
                },
              });

              if (result.isConfirmed) {
                setLoading(true);
                try {
                  const response = await dispatch(deleteTheme(theme.id));
                  if (response.payload && response.payload.status === 200) {
                    await SweetSweetAlert({
                      sweetData: response.payload.data.message,
                      icon: 'success',
                      buttonColor: 'green',
                    });
                  } else if (
                    response?.payload.data.message === 'Cannot delete theme as it is referenced by existing brandings.'
                  ) {
                    await SweetSweetAlert({
                      sweetData: response.payload.data.message,
                      icon: 'error',
                      buttonColor: 'red',
                    });
                  } else {
                    await SweetSweetAlert({
                      text: 'Something Wrong Please try again.!!',
                      icon: 'error',
                      buttonColor: 'red',
                    });
                  }
                } catch (error) {
                  await SweetSweetAlert({
                    text: 'Something Wrong Please try again.!!',
                    icon: 'error',
                    buttonColor: 'red',
                  });
                } finally {
                  await dispatch(getThemes());
                  setLoading(false);
                }
              }
            };

            const handleCustomize = async () => {
              setLoading(true);
              await dispatch(
                setThemeForCustomize({
                  baseTheme: theme.baseTheme,
                  themeName: theme.themeName,
                  defaultTheme: theme.defaultTheme,
                })
              );
              setLoading(false);
              navigate('/customize_theme');
            };

            return (
              <ThemeContentBox key={index} className='af-superadmin-themes-content-box-wrap'>
                <ThumbNailWrap className='af-superadmin-themes-thumbnail-wrap'>
                  <ImgWrap className='af-superadmin-themes-thumbnail-img-wrap'>
                    <img
                      className='af-superadmin-themes-thumbnail-img'
                      src={`${imageSrc}?cache=${new Date().getTime()}`}
                      alt={theme.themeName}
                      style={{ height: '100%', width: '100%', objectFit: 'fill' }}
                    />
                  </ImgWrap>
                  <ThemeNameDisplay className='af-superadmin-themes-box-label-wrap'>
                    <span className='af-superadmin-themes-box-name' style={{ marginLeft: '10px', fontWeight: 'bold' }}>
                      {theme.themeName}
                    </span>
                    {theme.isEdit && (
                      <ThemeActionButtonWrap className='af-superadmin-themes-box-action-wrap'>
                        <CustomizeButton className='af-superadmin-themes-box-action-custom' onClick={handleCustomize}>
                          Customize
                        </CustomizeButton>
                        <CustomizeButton
                          className='af-superadmin-themes-box-action-delete'
                          onClick={handleDelete}
                          style={{ marginLeft: '10px', backgroundColor: '#e24242' }}
                        >
                          Delete
                        </CustomizeButton>
                      </ThemeActionButtonWrap>
                    )}
                  </ThemeNameDisplay>
                </ThumbNailWrap>
              </ThemeContentBox>
            );
          } catch (error) {
            return null;
          }
        })
      );

      setThemeBoxes(fetchedBoxes.filter((box) => box !== null));
    };

    if (themeData && themeData.length > 0) {
      fetchThemeImages();
    }
  }, [themeData]);

  return (
    <AdminPageWrap className='af-superadmin-themes-wrap'>
      <AdminPageSizeWrap className='af-superadmin-themes-content'>
        {loading && <ModalOpenLoader />}
        <BackButton className='af-superadmin-themes-backbutton' to='/'>
          <LeftArrowIcon className='af-superadmin-themes-leftarrow' /> Back
        </BackButton>
        <Modal
          className='af-superadmin-themes-modal'
          open={isModalVisible}
          maskClosable={false}
          onCancel={() => setIsModalVisible(false)}
          footer={[null]}
          centered
          style={{ backgroundColor: 'white', borderRadius: '10px' }}
        >
          <Form
            className='af-superadmin-themes-form-element'
            size='large'
            name='register'
            layout='vertical'
            scrollToFirstError
            onFinish={handleCreateTheme}
          >
            <h2 className='af-superadmin-themes-heading'>Add New Theme:</h2>
            <FormItem
              className='af-superadmin-themes-form-item-themename'
              name='themeName'
              label='Theme Name'
              rules={[
                {
                  required: true,
                  message: `Please Enter the Theme Name`,
                },
              ]}
            >
              <Input placeholder='Name of Theme' className='af-superadmin-themes-input-themename' />
            </FormItem>
            <FormItem
              className='af-superadmin-themes-form-item-basename'
              name='baseTheme'
              label='Select Base Theme'
              rules={[
                {
                  required: true,
                  message: `Please Select the Base Theme`,
                },
              ]}
            >
              <Select
                allowClear
                showSearch
                placeholder='Select a Base Theme'
                className='af-superadmin-themes-select-basename'
              >
                {themeData.map((theme) => (
                  <Option
                    className='af-superadmin-themes-select-option-basename'
                    key={theme.id}
                    value={`${theme.themeName}|${theme.defaultTheme}`}
                  >
                    {theme.themeName}
                  </Option>
                ))}
              </Select>
            </FormItem>
            <FormItem className='af-superadmin-themes-form-item-submit'>
              <FormSubmitButtonConatainer className='af-superadmin-themes-submit-wrap'>
                <StyledButton className='af-superadmin-themes-submit-button' type='primary' htmlType='submit'>
                  Submit
                </StyledButton>
              </FormSubmitButtonConatainer>
            </FormItem>
          </Form>
        </Modal>
        <AdminTitleWrap className='af-superadmin-themes-title-wrap'>
          <h2 className='af-superadmin-themes-title-head'>Themes</h2>
          <StyledButton
            className='af-superadmin-themes-title-button'
            type='primary'
            style={{ margin: 0 }}
            onClick={() => setIsModalVisible(true)}
          >
            Add Theme
          </StyledButton>
        </AdminTitleWrap>
        <AntDivider className='af-superadmin-themes-divider' plain style={{ margin: 0 }}></AntDivider>
        {themeloading ? (
          <TableLoader />
        ) : (
          <CreateContendwrap style={{ overflow: 'auto' }} className='af-superadmin-themes-gridbox-wrap'>
            <ThemeContentWrap className='af-superadmin-themes-gridbox'>{themeBoxes}</ThemeContentWrap>
          </CreateContendwrap>
        )}
      </AdminPageSizeWrap>
    </AdminPageWrap>
  );
}
